// extracted by mini-css-extract-plugin
export default {"mask":"style_mask__l7gqs"};